(function () {
    'use strict';
    var controllerId = 'cndAccredSedeAdd7';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', '$uibModalInstance', 'cndAccredSede', 'cndAccreditamentoId', 'progettoId', 'paesi', 'province', 'tIndirizzi', fn_cndAccredSedeAdd7]);

    function fn_cndAccredSedeAdd7($scope, datacontext, $uibModalInstance, cndAccredSede, cndAccreditamentoId, progettoId, paesi, province, tIndirizzi) {
        $scope.paesi = paesi;
        $scope.province = province;
        $scope.tIndirizzi = tIndirizzi;
        $scope.comuni = [];

        //****** Method "Avanti"
        $scope.bFirst = false;
        $scope.activeTab2 = false;
        $scope.nextTab = function () {
            $scope.bFirst = false;
            $scope.activeTab2 = true;
        };
        //******* END

        if (cndAccredSede) {
            $scope.title = 'Modifica Sede';
            $scope.record = jQuery.extend({}, cndAccredSede); //Clona oggetto
            getComuni($scope.record.ProvinciaId);
            $scope.bFirst = false;
            if ($scope.record.Ref_CodiceFiscale && $scope.record.Ref_CodiceFiscale.length>0)
                isValidCF($scope.record.Ref_CodiceFiscale);

            if (($scope.record.DDG_Dt) != null) $scope.record.DDG_Dt = new Date($scope.record.DDG_Dt);
        }
        else {
            $scope.title = 'Nuova Sede';
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.PaeseId = 0;
            $scope.record.TIndirizzoId = 1;
        }

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1) {
                $scope.opened1 = true;
            }

        };

        $scope.clear = function ($event, iOpened) {
            console.log('clear');
            if (iOpened == 1) {
                $scope.record.DDG_Dt = '';
                $scope.changed = true;
            }

        };

        if (progettoId) {
            $scope.progettoId = progettoId;
        }


        if (cndAccreditamentoId) {
            $scope.cndAccreditamentoId = cndAccreditamentoId;
            $scope.record.cndAccreditamentoId = cndAccreditamentoId;
        }

        $scope.resetPaese = function () {
            if ($scope.record.PaeseId > 0) {
                $scope.record.ProvinciaId = 0;
                $scope.record.ComuneId = 0;
            }
        };

        $scope.change_Comuni = function (idProv) {
            $scope.record.ComuneId = '';
            getComuni(idProv);
        };

        function getComuni(idprov) {
            if (!idprov || idprov == 0) return $scope.comuni = [];

            if ($scope.record.ProvinciaId != idprov)
                $scope.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.comuni = data;
            });
        }

        $scope.ok = function (isValid) {
            if (isValid) {
                if ($scope.record.Id == 0) {
                    var result = addItem($scope.record);
                    $uibModalInstance.close(result);
                }
                else {
                    var result2 = updateItem($scope.record);
                    $uibModalInstance.close(result2);
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.cndAccreditamentoSede_add(item).then(function (data) {
                return data;
            });
        }

        function updateItem(item) {
            return datacontext.cndAccreditamentoSede_update(item).then(function (data) {
                return data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID CODICE FISCALE -#-#-#-#-#-#
        $scope.validCF = true;
        $scope.isValidCF = isValidCF;
        function isValidCF(value) {
            console.log('isValidCF()');
            $scope.validCF = false;
            return datacontext.validazione_cf(value).then(function (data) {
                $scope.validCF = data;
            });
        }

    }
})();